import {
  ActionIcon,
  Button,
  Group,
  Popover,
  Stack,
  TextInput,
  Tooltip,
} from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { useState } from "react";
import { createPool } from "../../../../../api/EmailAPI";
import { createFolder } from "../../../../../api/FolderAPI";
import { useLanguage } from "../../../../../stores/LanguageStore";

const FolderAdder = ({ isPool, type, onFinish, isButton }) => {
  const lang = useLanguage((s) => s.language);
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    const main = isPool ? createPool : createFolder;
    main({ name: data.name, type })
      .then(() => {
        setOpened(false);
        onFinish?.();
      })
      .finally(() => setLoading(false));
  };

  return (
    <Popover opened={opened} onChange={setOpened} withinPortal={false}>
      <Popover.Target>
        {isButton ? (
          <Button
            leftSection={<IconPlus />}
            size="md"
            radius={"md"}
            fz={16}
            ml={"auto"}
            onClick={() => setOpened(true)}
          >
            {isPool
              ? lang.pools.create.dialog.title
              : lang.components.folder_navigator.column_name}
          </Button>
        ) : (
          <Tooltip
            label={
              isPool
                ? lang.pools.create.dialog.title
                : lang.components.folder_navigator.create.new
            }
          >
            <ActionIcon
              size={"xl"}
              variant="light"
              radius={"md"}
              onClick={() => setOpened(true)}
            >
              <IconPlus />
            </ActionIcon>
          </Tooltip>
        )}
      </Popover.Target>

      <Popover.Dropdown>
        <Stack component={"form"} onSubmit={handleSubmit} w={200}>
          <TextInput
            label={
              isPool
                ? lang.pools.create.dialog.name
                : lang.components.folder_navigator.create.name
            }
            name="name"
            autoFocus
            required
          />
          <Group wrap="nowrap" justify="end">
            <Button
              size="compact-sm"
              variant="subtle"
              disabled={loading}
              onClick={() => setOpened(false)}
            >
              {lang.components.closer.submit}
            </Button>
            <Button type="submit" loading={loading} size="compact-sm">
              {lang.contact_lists.edit.dialog.submit_button}
            </Button>
          </Group>
        </Stack>
      </Popover.Dropdown>
    </Popover>
  );
};

export default FolderAdder;
